module.exports = __webpack_public_path__ + "static/media/jiraLogo.7817ccfa.png";